(function () {
  'use strict';

  var FLAG_KEY = 'woodypanel_pdp_atc';
  var PAYLOAD_KEY = 'woodypanel_maak_compleet_data';
  var FLAG_TTL_MS = 10000;

  function readConfig() {
    var el = document.querySelector('script[data-pdp-complete-config]');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function stashPayload(config, variantId) {
    try {
      sessionStorage.setItem(PAYLOAD_KEY, JSON.stringify({
        product: config.product,
        sections: config.sections,
        bundle: config.bundle || null,
        triggerVariantId: variantId || null
      }));
      sessionStorage.setItem(FLAG_KEY, JSON.stringify({
        ts: Date.now(),
        productId: config.product.id,
        variantId: variantId || null,
        redirectUrl: config.redirectUrl
      }));
    } catch (e) {}
  }

  function readFlag() {
    try {
      var raw = sessionStorage.getItem(FLAG_KEY);
      if (!raw) return null;
      var flag = JSON.parse(raw);
      if (!flag || typeof flag.ts !== 'number') return null;
      if (Date.now() - flag.ts > FLAG_TTL_MS) {
        sessionStorage.removeItem(FLAG_KEY);
        return null;
      }
      return flag;
    } catch (e) {
      return null;
    }
  }

  function clearFlag() {
    try { sessionStorage.removeItem(FLAG_KEY); } catch (e) {}
  }

  window.WoodypanelMaakCompleet = {
    // Returns true if it handled the post-ATC flow (i.e. started a redirect),
    // so theme.js knows to skip opening the cart drawer.
    maybeRedirectAfterAtc: function () {
      var flag = readFlag();
      if (!flag) return false;
      clearFlag();
      var url = flag.redirectUrl + '?id=' + encodeURIComponent(flag.productId);
      if (flag.variantId) url += '&variant=' + encodeURIComponent(flag.variantId);
      window.location.href = url;
      return true;
    }
  };

  function attachSubmitListener(config) {
    var configScript = document.querySelector('script[data-pdp-complete-config]');
    if (!configScript) return;
    var configSection = configScript.closest('.shopify-section');

    document.querySelectorAll('form[is="product-form"]').forEach(function (form) {
      var section = form.closest('.shopify-section');
      if (section !== configSection) return;

      form.addEventListener('submit', function (event) {
        if (!config.active) return;
        var variantInput = form.querySelector('[name="id"]');
        var variantId = variantInput ? variantInput.value : null;
        stashPayload(config, variantId);
      }, { capture: true });
    });
  }

  function init() {
    var config = readConfig();
    if (!config) return;
    attachSubmitListener(config);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
